import {
  postProxy,
  PostProxy,
  getProxyList,
  PutProxy,
  putProxy,
  GetProxy,
  DelProxy,
  delProxy,
  getAgentPool,
  GetAgentPool,
  postAgentPool,
  PostAgentPool,
  DeleteAgentPool,
  deleteAgentPool,
  putAgentPool,
} from '@/api/waf-create-task'
import { Message } from '@/components/message'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { t } from '@/i18n'
// 获取代理池
export const useGetAgentPool = () => {
  const {
    runAsync: run,
    loading,
    data,
  } = useRequest((datas: GetAgentPool) => getAgentPool(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取代理池列表失败'))
    },
  })

  return [run, loading, data?.data || []] as const
}
// 删除代理池
export const useDeleteAgentPool = () => {
  const { runAsync, loading } = useRequest((data: DeleteAgentPool) => deleteAgentPool(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除代理池失败'))
    },
  })
  return [runAsync, loading] as const
}

export const usePostProxy = () => {
  const { runAsync, loading } = useRequest((data: PostProxy) => postProxy(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('添加代理失败'))
    },
  })
  return [runAsync, loading] as const
}
export const usePutProxy = () => {
  const { runAsync, loading } = useRequest((data: PutProxy) => putProxy(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('修改代理失败'))
    },
  })
  return [runAsync, loading] as const
}
export const useDelProxy = () => {
  const { runAsync, loading } = useRequest((data: DelProxy) => delProxy(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('删除代理失败'))
    },
  })
  return [runAsync, loading] as const
}

export const useGetProxyList = () => {
  const { data, runAsync, loading } = useRequest((datas: GetProxy) => getProxyList(datas), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('获取代理失败'))
    },
  })
  return [data?.data || [], runAsync, loading] as const
}

export const usePostAgentPool = () => {
  const { runAsync, loading } = useRequest((data: PostAgentPool) => postAgentPool(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('新增代理池失败'))
    },
  })
  return [runAsync, loading] as const
}

export const usePutAgentPool = () => {
  const { runAsync, loading } = useRequest((data: PostAgentPool) => putAgentPool(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || t('编辑代理池失败'))
    },
  })
  return [runAsync, loading] as const
}
